// Provisional ONI-332 palette; Nacka's K1–K3 decisions remain open.
export const nackaLight = {
  name: 'nacka:light',
  extends: 'citizen2:light',
  cssPath: 'custom/styles/citizen-light.theme',
  vuetify: {
    defaults: {
      VBtn: { rounded: 'lg' },
      VCard: { rounded: 'lg' },
      HItemCard: {
        VCard: { rounded: 'lg', elevation: 0 },
        HScopedItemCardActionBtn: { color: 'primary', variant: 'flat', rounded: 'lg' },
        HScopedItemCardMenuBtn: {
          appendIcon: 'mdi:mdi-chevron-down',
          color: 'primary',
          variant: 'flat',
          rounded: 'lg',
        },
      },
    },
    theme: {
      dark: false,
      colors: {
        primary: '#0077B7',
        'on-primary': '#FFFFFF',
        'primary-darken-1': '#00649B',
        'primary-lighten-1': '#338FC5',
        'primary-lighten-2': '#66ADD4',
        'primary-lighten-3': '#99C9E2',
        'primary-lighten-4': '#E6F1F8',
        secondary: '#E6F1F8',
        'on-secondary': '#000000',
        'secondary-hover': '#CCE4F1',
        'secondary-lighten-1': '#E6F1F8',
        'secondary-lighten-2': '#E6F1F8',
        'secondary-lighten-3': '#E6F1F8',
        tertiary: '#E6E6E6',
        accent: '#0077B7',
        'on-accent': '#FFFFFF',
        surface: '#FFFFFF',
        'on-surface': '#000000',
        'surface-variant': '#E6E6E6',
        'on-surface-variant': '#000000',
        'surface-gradient': '#FFFFFF',
        'surface-gradient-2': '#FFFFFF',
        'on-surface-gradient': '#000000',
        background: '#F7F7F7',
        'on-background': '#000000',
        'background-3': '#F7F7F7',
        'on-background-3': '#000000',
        'background-4': '#E6E6E6',
        'on-background-4': '#000000',
        neutral: '#E6E6E6',
        'neutral-100': '#FFFFFF',
        'on-neutral-100': '#000000',
        'neutral-variant': '#F7F7F7',
        'on-neutral-variant': '#000000',
        'text-color-primary': '#000000',
        'text-color-secondary': '#414141',
        'search-list-hover': '#E6F1F8',
        'breadcrumb-hover': '#E6E6E6',
        'on-breadcrumb': '#000000',
        toolbar: '#FFFFFF',
        'on-toolbar': '#000000',
        'header-button': '#0077B7',
        'on-header-button': '#FFFFFF',
        'dialog-header-button': '#0077B7',
        'badge-primary': '#0077B7',
        'on-badge-primary': '#FFFFFF',
        'badge-secondary': '#E6F1F8',
        'on-badge-secondary': '#000000',
        'badge-tertiary': '#0077B7',
        'on-badge-tertiary': '#FFFFFF',
        bulletin: '#FFFFFF',
        'bulletin-2': '#FFFFFF',
        'on-bulletin': '#000000',
        'bulletin-board': '#F7F7F7',
        'bulletin-board-2': '#F7F7F7',
        'on-bulletin-board': '#000000',
        'bulletin-informational': '#E6F1F8',
        'on-bulletin-informational': '#000000',
        'bulletin-informational-button': '#0077B7',
        'bulletin-informational-button-hover': '#00649B',
        'start-page': '#F7F7F7',
        'on-start-page': '#000000',
        loader: '#FFFFFF',
        'loader-background': '#0077B7',
        scrollbar: '#0077B7',
        // Keep the existing semantic status palette and provide readable foregrounds.
        'on-error': '#FFFFFF',
        'on-success': '#FFFFFF',
        'on-warning': '#000000',
        'chip-active': '#0077B7',
        'on-chip-active': '#FFFFFF',
        'chip-inactive': '#E6E6E6',
        'on-chip-inactive': '#000000',
        'my-cases': '#E6F1F8',
        'on-my-cases': '#000000',
        'my-cases-action': '#0077B7',
        'on-my-cases-action': '#FFFFFF',
        foretag: '#E6F1F8',
        'on-foretag': '#000000',
        fastigheter: '#E6F1F8',
        'on-fastigheter': '#000000',
        fullmakter: '#E6F1F8',
        'on-fullmakter': '#000000',
        'sector-privat': '#E6F1F8',
        'sector-företag': '#E6F1F8',
        'on-sector-privat': '#000000',
        'on-sector-företag': '#000000',
        'page-companies-header-bg': '#FFFFFF',
        'on-page-companies-header-bg': '#000000',
        'page-properties-header-bg': '#FFFFFF',
        'on-page-properties-header-bg': '#000000',
        'page-cases-header-bg': '#FFFFFF',
        'on-page-cases-header-bg': '#000000',
        'card-company': '#0077B7',
        'card-property': '#0077B7',
        'card-case': '#0077B7',
      },
    },
  },
};
